class Controller {
  constructor(Events, Sections, $stateParams) {
    "ngInject";

    this.Events = Events;
    this.filterEvent = this.Events.getFilterEvent("basicplan");
    this.paginateEvent = this.Events.getPaginateEvent("basicplan");
    this.sortEvent = this.Events.getSortEvent("basicplan");
    this.addItemEvent = this.Events.getAddEvent("basicplan");

    this.page = $stateParams.page;
    this.limit = $stateParams.limit;

    this.sections = Sections.plansSections;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/basicplans/basicplans.controller.js